// 根据用户的设备类型来决定 点击顶部导航栏跳转的页面
// import { detail } from "@/api/official";
export default {
  data() {
    return {
      flag: []
    };
  },
  created() {
    this.flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    this.$store.state.customer.userDeviceInfo = this.flag;

    let nowPath = this.$route.path;
    let phonePath = "/phone" + nowPath;
    if (this.flag && this.$route.meta.isAdapterPhone) {
      this.$router.push({
        path: phonePath
      });
    } else {
      if (
        this.$route.name == "userInfo" ||
        this.$route.name == "orderInfo" ||
        this.$route.name == "qrPay" ||
        this.$route.name == "qrPay"
      ) {
        // this._getDetail();
      }
    }
  },
  methods: {
    clickTab(e) {
      // pc端的导航栏点击
      if (e.label == "首页") {
        this.$router.push({ name: this.flag ? "phoneHome" : "Home" });
      } else if (e.label == "专业技术") {
        this.$router.push({ name: this.flag ? "phoneExpertise" : "expertise" });
      } else if (e.label == "产品中心") {
          this.$router.push({ name: this.flag ? "phoneShopPage" : "shopPage" });
      } else if (e.label == "关于我们") {
        this.$router.push({ name: this.flag ? "phoneAboutUs" : "aboutUs" });
      } else if (e.label == "用户中心") {
        this.$router.push({
          name: this.flag ? "phoneUserCenter" : "userCenter"
        });
      }  else if (e.label == "企业新闻板") {
          this.$router.push({
              name: this.flag ? "phoneBulletInBoard" : "bulletInBoard"
          });
      }  else if (e.label == "听觉名医录") {
          this.$router.push({
              name: this.flag ? "phoneDoctorMyPage" : "doctorMyPage"
          });
      } else if (e.label == "企业新闻") {
        this.$router.push({
          name: this.flag ? "phoneArticles" : "articles"
        });
      } else if (e.label == "名家新作") {
          this.$router.push({
              name: this.flag ? "doctorPhoneArticles":"doctorArticles"
      });
      } else if (e.label == "下载中心") {
        this.$router.push({
          name: this.flag ? "phone-DownloadCenter" : "downloadCenter"
        });
      }
    },

    onSelect(e) {
      // 移动端的导航栏点击
      if (e.text == "首页") {
        this.$router.push({ name: this.flag ? "phoneHome" : "Home" });
      } else if (e.text == "产品中心") {
          this.$router.push({ name: this.flag ? "phoneShopPage" : "shopPage" });
      } else if (e.text == "专业技术") {
        this.$router.push({
          name: this.flag ? "phoneExpertise" : "expertise"
        });
      } else if (e.text == "关于我们") {
        this.$router.push({
          name: this.flag ? "phoneAboutUs" : "aboutUs"
        });
      }  else if (e.text == "名家新作") {
          this.$router.push({
              name: this.flag ? "doctorPhoneArticles":"doctorArticles"
          });
      }  else if (e.text == "听觉名医录") {
          this.$router.push({
              name: this.flag ? "phoneDoctorMyPage" : "doctorMyPage"
          });
      }  else if (e.text == "电子公告板") {
          this.$router.push({
              name: this.flag ? "phoneBulletInBoard" : "bulletInBoard"
          });
      }  else if (e.text == "用户中心") {
        this.$router.push({
          name: this.flag ? "phoneUserCenter" : "userCenter"
        });
      } else if (e.text == "企业新闻") {
        this.$router.push({
          name: this.flag ? "phoneArticles" : "articles"
        });
      } else if (e.text == "下载中心") {
        this.$router.push({
          name: this.flag ? "phone-DownloadCenter" : "DownloadCenter"
        });
      } else if (e.text == '个人中心') {
        if(this.$store.state.customer.customerInfo.mobile){
          this.$router.push({
            name: this.flag ? "userHome" : "userCenter"
          })
        }else{
          // this.$router.push({
          //   name: this.flag ? "login" : "phoneUserLogin"
          // })
          this.$router.push({
            name: "phoneUserLogin"
          })
        }
      }
    },
    async _getDetail() {
      let res = await detail({});
      if (res.status == 0) {
        let userRow = res.data;
        this.$store.state.userInfo = userRow;
        this.$store.state.user_id = userRow.user_id;
      }
    }
  }
};
